export const BANNER_TYPE = {
    1: 'img',
    2: 'video'
};

export const BANNER_TYPE2NUM = {
    'img': 1,
    'video': 2
};

export const SENTRY_INITIATIVE_LABEL = {
    // banner
    banner: 'banner',
    // 即将上线课程预约
    subscribe: 'subscribe',
    // 播放器播放异常
    player: 'player'
};

export const SPM_ID_FROM_BANNER = '333.874.selfDef.home_banner_click';
export const SPM_ID_FROM_RECOMMEND = '333.874.selfDef.home_selected_click';
export const SPM_ID_FROM_NEWSEASON = '333.874.selfDef.home_newseason_click';
export const SPM_ID_FROM_RANK = '333.874.selfDef.home_ranklist_click';
export const SPM_ID_FROM_RESOURCE = '333.874.selfDef.home_sort_click';
export const SPM_ID_FROM_PAYED = '333.874.selfDef.home_purchased_click';
export const SPM_ID_FROM_MORESEASON = '333.874.selfDef.home_moreseason_click';
export const SPMID_REPORT_MAP = {}
SPMID_REPORT_MAP[SPM_ID_FROM_RECOMMEND] = 'select_lectures'
SPMID_REPORT_MAP[SPM_ID_FROM_NEWSEASON] = 'new_lectures'
SPMID_REPORT_MAP[SPM_ID_FROM_MORESEASON] = 'distribute_lesson'